import(/* webpackMode: "eager", webpackExports: ["Box","Typography","Link","Button"] */ "__barrel_optimize__?names=Box,Button,Link,Typography!=!/app/node_modules/@mui/material/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/ArrowBack.js");
